import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import Calendar from "~/views/calendar"

const getInitialProps: GetInitialPropsType = async ({ req, query: { slug, ...query } }) => {
  const apiContext = await getApiContext(
    [
      {
        url: "/calendar/list",
        query: {
          status: "active",
          items_per_page: 10,
          page_number: 1,
          ...query,
        },
      },
    ],
    req ? req.headers.host : location.host,
  )

  const crumbs = generateCrumbs(req?.url)

  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
Calendar.getInitialProps = getInitialProps

export default Calendar
